var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.916 12.9999L12.3803 7.99992M7.6184 7.99992L2.08271 12.9999M1.66602 3.83325L8.47012 8.59612C9.02109 8.9818 9.29658 9.17465 9.59624 9.24934C9.86093 9.31532 10.1378 9.31532 10.4025 9.24934C10.7021 9.17465 10.9776 8.9818 11.5286 8.59612L18.3327 3.83325M5.66602 14.6666H14.3327C15.7328 14.6666 16.4329 14.6666 16.9677 14.3941C17.4381 14.1544 17.8205 13.772 18.0602 13.3016C18.3327 12.7668 18.3327 12.0667 18.3327 10.6666V5.33325C18.3327 3.93312 18.3327 3.23306 18.0602 2.69828C17.8205 2.22787 17.4381 1.84542 16.9677 1.60574C16.4329 1.33325 15.7328 1.33325 14.3327 1.33325H5.66602C4.26588 1.33325 3.56582 1.33325 3.03104 1.60574C2.56063 1.84542 2.17818 2.22787 1.9385 2.69828C1.66602 3.23306 1.66602 3.93312 1.66602 5.33325V10.6666C1.66602 12.0667 1.66602 12.7668 1.9385 13.3016C2.17818 13.772 2.56063 14.1544 3.03104 14.3941C3.56582 14.6666 4.26588 14.6666 5.66602 14.6666Z",
    stroke: "#80899C",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFooter);
export default __webpack_public_path__ + "static/media/email-footer.eda8d246ef36428e9da5d44e85f502c1.svg";
export { ForwardRef as ReactComponent };